import { useMemo } from 'react';
import { addMediaAccountConnectClick, addMediaAccountDisconnectClick } from '@wix/bi-logger-media-manager-g6/v2';
import { bi } from '../../../services/loggers/bi';

export const useTrackAddMediaAccountAnalytics = () =>
  useMemo(
    () => ({
      trackAddMediaAccountConnectConnected: (externalSource) => {
        // Although method name is `addMediaAccountConnectClick`
        // but in fact it tracks when external source was actually connected (not when user clicked on "Connect" button).
        // It happened because event name (and meaning) changed but unfortunately it can not be changed in library.
        bi.logger().report(
          addMediaAccountConnectClick({
            target: externalSource,
          }),
        );
      },
      trackAddMediaAccountConnectDisconnected: (externalSource) => {
        bi.logger().report(
          addMediaAccountDisconnectClick({
            target: externalSource,
          }),
        );
      },
    }),
    [],
  );
